<mat-label>{{ 'folder_selector.folder' | translate }}</mat-label>
<mat-form-field appearance="outline" class="full-width" (click)="inputOnFocus()">
  <mat-icon matPrefix class="mr-10">folder</mat-icon>
  <input matInput readonly [value]="path$ | async">
</mat-form-field>
